/**
 * Web-only native `<input type="date">` styled with Vuelto control tokens.
 * Pair with InventoryIsoDateField (native platforms use DateTimePicker).
 *
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React, { createElement } from 'react';
import { View } from 'react-native';
import {
  webNativeTemporalInputStyle,
  type WebNativeTemporalSize,
} from './webNativeTemporalInput';

type Props = {
  value: string;
  onChange: (isoDate: string) => void;
  ariaLabel?: string;
  disabled?: boolean;
  size?: WebNativeTemporalSize;
  /** ISO 'YYYY-MM-DD' — mínimo seleccionable en el picker nativo de fecha web. */
  min?: string;
};

export const WebExpiryDateInput = ({
  value,
  onChange,
  ariaLabel = 'Fecha',
  disabled = false,
  size = 'comfortable',
  min,
}: Props) => {
  return (
    <View style={{ width: '100%' }}>
      {createElement('input', {
        type: 'date',
        value: /^\d{4}-\d{2}-\d{2}$/.test(value.trim()) ? value.trim() : '',
        min: min && /^\d{4}-\d{2}-\d{2}$/.test(min) ? min : undefined,
        disabled,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value ?? ''),
        style: webNativeTemporalInputStyle({ size }),
        'aria-label': ariaLabel,
      })}
    </View>
  );
};
